import { useEffect, useState } from "react";
import {
    PaymentElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";
import { Button, Spinner } from "react-bootstrap";
import usePayment from "../../../../../hooks/usePayment";
import useMask from "../../../../../hooks/useMask";

interface Props {
    clientSecret: string;
    callOnFinish: CallableFunction
}
export default function CheckoutForm({ clientSecret, callOnFinish }: Props) {
    const stripe = useStripe();
    const elements = useElements();
    const { addCardMethod } = usePayment()
    const { maskCPF, isCPFValid: checkIfCpfIsValid } = useMask();

    const [errorMsg, setErrorMsg] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [cpfValue, setCpfValue] = useState<string>('');
    const [fullNameValue, setFullNameValue] = useState<string>('');
    const [isCpfValid, setIsCpfValid] = useState<boolean>(true);


    //Set error display on CPF validation failed
    useEffect(() => {
        setIsCpfValid(true);

        if (cpfValue.length === 14) {
            const newIsValid = checkIfCpfIsValid(cpfValue);
            setIsCpfValid(newIsValid);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cpfValue])

    function handleNextPage() {
        return callOnFinish();
    }

    async function handleSubmit(e: any) {
        e.preventDefault();
        setErrorMsg('');

        if (!checkIfCpfIsValid(cpfValue)) {
            setErrorMsg('O CPF Inserido é inválido, por favor, verifique o CPF inserido e tente novamente.')
            return
        }


        if (!stripe || !elements) {
            console.log('stripe or elements not loaded');
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setIsLoading(true);

        const { error } = await stripe.confirmSetup({
            elements,
            redirect: 'if_required'
        });

        if (!error) {
            // Card accepted
            const { setupIntent } = await stripe.retrieveSetupIntent(clientSecret);
            const paymentMethodId = String(setupIntent?.payment_method);
            const onlyDigitsCPF = cpfValue.replace(/\D/g, '');

            const isStoredSuccessfully = await addCardMethod(paymentMethodId, fullNameValue, onlyDigitsCPF)
            if (isStoredSuccessfully) {
                return handleNextPage()
            }
        } else {
            //Card rejected
            setErrorMsg('Ocorreu um erro ao processar os dados do cartão, por favor, verifique os dados e tente novamente.')
        }


        setIsLoading(false);
    }


    function handleCpfChange(event: any) {
        const { value } = event?.target;
        setCpfValue(maskCPF(value));
    }


    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            <div>
                <label className="form-label text-black tx-14">
                    Nome do titular
                </label>
                <input className="form-control tx-15" type="text" value={fullNameValue} minLength={4}
                    maxLength={255} style={{ borderRadius: 10 }} required placeholder="Nome do titular"
                    onChange={(e) => setFullNameValue(String(e?.target?.value).toUpperCase())} />
            </div>

            <div className="pd-t-8 pd-b-12">
                <label className={!isCpfValid ? "form-label text-danger tx-14" : "form-label text-black tx-14"}>
                    CPF
                </label>
                <input className={'form-control tx-15'} placeholder="999.999.999-99" required minLength={14} maxLength={14} type="text" value={cpfValue} style={!isCpfValid ? { borderRadius: 10, color: 'red', borderColor: 'red' } : { borderRadius: 10 }} onChange={handleCpfChange} />
            </div>

            <PaymentElement id="payment-element" options={{ layout: 'tabs' }} />

            <div className="d-flex align-items-center justify-content-center pd-t-10 pd-b-10">
                <Button style={{ borderRadius: 15 }} disabled={isLoading || !stripe || !elements} id="submit" type="submit">
                    <span id="button-text">
                        {isLoading ? <Spinner animation="border" size="sm" /> : "Continuar"}
                    </span>
                </Button>
            </div>
            {/* Show any error or success messages */}
            {errorMsg && <p id="payment-message" className="tx-15 text-center text-danger">{errorMsg}</p>}
        </form>
    );
}